module.exports = __webpack_public_path__ + "img/um.0561511.svg";